module.exports = __webpack_public_path__ + "static/media/pppb.1b90cbdc.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/portfolio/thumbnails/pppb.gif
// module id = 255
// module chunks = 0